<template>
  <Select
    v-model="type"
    clearable
    placeholder="请筛选营销场景"
    @change="handleChange"
  >
    <Option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </Select>
</template>

<script>
import { Select, Option } from 'element-ui';

export default {
  components: {
    Select,
    Option,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      default: '',
    },
  },

  data() {
    return {
      options: [
        // {
        //   value: 0,
        //   label: '全部',
        // },
        {
          value: 1,
          label: '拉新',
        },
        {
          value: 2,
          label: '拉活',
        },
      ],
      type: this.value,
    };
  },

  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
